import { PLAYER_STATE } from '@/helpers/VodPlayer';

/**
 * Zustaende des Video-Players fuer die Seiten.
 *
 * Einzige Quelle ist PLAYER_STATE aus helpers/VodPlayer - hier steht nur die
 * Weitergabe plus die beiden ALTEN Namen PLAY und PAUSE, mit denen der
 * MediaPlayer die Wiedergabe frueher ueber das status-Attribut gesteuert hat.
 * Sie zeigen bewusst auf dieselben Werte wie PLAYING/PAUSED, damit ein
 * Vergleich in bestehendem Code weiter stimmt.
 */
export default {
  ...PLAYER_STATE,
  PLAY: PLAYER_STATE.PLAYING,
  PAUSE: PLAYER_STATE.PAUSED,
};



// WEBPACK FOOTER //
// ./src/components/VideoPlayer/VideoPlayerStates.js